import { apiGetFile, GetReportRequest } from 'api';

export const getRespondedYearToDateReportCsv = (request: GetReportRequest): Promise<Blob> =>
  apiGetFile('reports/respondedytd/csv', request);
